import { render } from "./designfoodslide5.vue?vue&type=template&id=4a61a98a&scoped=true"
import script from "./designfoodslide5.vue?vue&type=script&lang=js"
export * from "./designfoodslide5.vue?vue&type=script&lang=js"

import "./designfoodslide5.vue?vue&type=style&index=0&id=4a61a98a&lang=less&scoped=true"

import exportComponent from "/Users/zhoubenhao/Desktop/行云/numatch/numatch-home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a61a98a"]])

export default __exports__